angular.module('gym.privacy_policies').controller('PrivacyPoliciesCtrl', ["$scope", "$window", "loadingAnimation", "flash", "ngTableParams", "PrivacyPolicies", "policiesMeta", function($scope, $window, loadingAnimation, flash, ngTableParams, PrivacyPolicies, policiesMeta) {
  $scope.tableParams = new ngTableParams({
    page: 1,
    count: 1000
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      loadingAnimation.show();
      return PrivacyPolicies.getList($params.url()).then(function(data) {
        $params.total(data.meta.total);
        $defer.resolve(data);
        return loadingAnimation.hide();
      });
    }
  });
  $scope.toggle = function(policy) {
    return policy.save().then(function(response) {
      return angular.noop;
    }, function() {
      policy.enabled = !policy.enabled;
      return flash.error = 'Unable to update consent clause';
    });
  };
  return $scope.remove = function(policy) {
    if ($window.confirm("Are you sure you want to delete this consent clause?")) {
      return policy.remove().then(function() {
        return $scope.tableParams.reload();
      });
    }
  };
}]);
